<template>
  <fragment>
    <hero-header page-name="" hero-title="ourStores"/>
    <!--v-container class="my-10">
      <v-row>
        <v-col cols="12" class="warning py-5">
          <div v-html="$t('storeOpeningCovid')" class="text-center"></div>
        </v-col>
      </v-row>
    </v-container-->
    <!--v-container fluid>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" class="text-center display-1 mb-5">
            {{ $t('xmasOpening') }}
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card dark color="red darken-1" class="fill-height" tile>
              <v-card-title>
                <v-icon large left>
                  mdi-pine-tree
                </v-icon>
                <span class="title font-weight-light">
                    Huawei Hillside
                  </span>
              </v-card-title>
              <v-card-text class="body-1 py-6 px-5">
                2020. december 24 - 2021. január 3: ZÁRVA
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card dark color="red darken-1" class="fill-height" tile>
              <v-card-title>
                <v-icon large left>
                  mdi-pine-tree
                </v-icon>
                <span class="title font-weight-light">
                    Huawei CSC József krt.
                  </span>
              </v-card-title>
              <v-card-text class="body-1 py-6 px-5">
                December 24-27: ZÁRVA<br>December 28-30: 9:00 - 19:00 (új ügyfél fogadása 18:30-ig)<br>December 31: 9:00 - 14:00<br>Január 1-3: ZÁRVA
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container-->
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" class="mb-10">
          <div v-html="$t('pageStores.part1')" class="mb-10"></div>
        </v-col>
        <template v-for="(store, index) in $store.state.tmxStores.tmxStores.features">
          <v-col cols="12" md="4" :key="index">
            <store-card v-bind:store-data="store" v-on:on-image-click="scrollToPosition"/>
          </v-col>
        </template>
        <v-col cols="12" id="storeMap">
          <google-map class="webportal-google-map"
                      :geo-json="$store.state.tmxStores.tmxStores"
                      :zoom-value="12" :center-pos="[19.070615, 47.494666]"/>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import storeCard from '../components/storeCard.vue';
import googleMap from '../components/googleMap.vue';

export default {
  name: 'tmxStores',
  components: {
    heroHeader, storeCard, googleMap,
  },
  data() {
    return {
      scrollOptions: {
        duration: 900,
        offset: 60,
      },
    };
  },
  methods: {
    scrollToPosition() {
      this.$vuetify.goTo('#storeMap', this.scrollOptions);
    },
  },
};
</script>

<style scoped>

</style>
